import axios from "axios";


export const validateInvitationCode = (guid,captchaToken) =>
axios.get(`/eps/api/cps-request-registration/validate-invitation-code/${guid}`,{
  headers: {
    Captcha: captchaToken
  }
});

export const registerCPSMember = (registry,captchaToken) => {
    return axios.post(`/eps/api/cps-request-registration/register`, registry,{
      headers: {
        Captcha: captchaToken
      }

    })
  }

